import { combineReducers } from 'redux';
import { MonHocReducer } from '../faetures/mon-hoc/monHocSlice';
import { authReducer } from '../faetures/auth/authSlice';
import { DanhSachThiSinhDangKyReducer } from '../faetures/danh-sach-thi-sinh-dang-ky/danhSachThiSinhDangKySlice';
import { ChuyenNganhReducer } from '../faetures/chuyen-nganh/chuyenNganhSlice';
import { ChuyenNganhTotNghiepReducer } from '../faetures/chuyen-nganh-tot-nghiep/chuyenNganhTotNghiepSlice';
import { DanhSachLopReducer } from '../faetures/danh-sach-sinh-vien-lop/danhSachSinhVienLopSlice';
import { DiemReducer } from '../faetures/diem/diemSlice';
import { DoiTuongTuyenSinhReducer } from '../faetures/doi-tuong-tuyen-sinh/doiTuongTuyenSinh';
import { dotHocReducer } from '../faetures/dot-hoc/dotHocSlide';
import { giaoVienReducer } from '../faetures/giao-vien/giaoVienSlice';
import { loaiNganhReducer } from '../faetures/loai-nganh/loaiNganhSlice';
import { suKienReducer } from '../faetures/su-kien-tin-chi(tkb)/suKienTinChiSlice';
import { lopTinChiReducer } from '../faetures/lopTinChi/lopTinChiSlice';
import { phongHocReducer } from '../faetures/phong-hoc/PhongHocSlice';

const rootReducer = combineReducers({
    auth: authReducer,
    monhoc: MonHocReducer,
    danhSachThiSinhDangKy: DanhSachThiSinhDangKyReducer,
    chuyenNganh: ChuyenNganhReducer,
    chuyenNganhTotNghiep: ChuyenNganhTotNghiepReducer,
    danhSachLop: lopTinChiReducer,
    diem: DiemReducer,
    doiTuongTuyenSinh: DoiTuongTuyenSinhReducer,
    doiTuongTuyenSinhMonHoc: DoiTuongTuyenSinhReducer,
    dotHoc: dotHocReducer,
    giaoVien: giaoVienReducer,
    loaiNganh: loaiNganhReducer,
    danhSachSinhVienLopTinChi: DanhSachLopReducer,
    suKienTinChi: suKienReducer,
    phongHoc: phongHocReducer
});

export default rootReducer;
